//  @flow
export const ONBOARDING_ADD_ITEM = "ONBOARDING_ADD_ITEM";
export const ONBOARDING_REMOVE_ITEM = "ONBOARDING_REMOVE_ITEM";